import { Table } from "@/features/Table";

import { type A7OPCVMUnderlying, getUnderlyingsColumns } from "./columns";
import {
  FilterA7OPCVMUnderlyings,
  filterA7OPCVMUnderlyingsSchema,
} from "./filter";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_opcvm_underlyings";

export const A7OPCVMUnderlyingsTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getUnderlyingsColumns(t), [t, i18n.language]);

  return (
    <Table<A7OPCVMUnderlying, typeof filterA7OPCVMUnderlyingsSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Financial instruments",
      })}
      table_name={table_name}
      columns={columns}
      filter={<FilterA7OPCVMUnderlyings />}
      client="a7"
      disable_translations_request={true}
    />
  );
};
